import {
  BLANK,
  CANCELINVITATION_FAILURE,
  CANCELINVITATION_REQUEST,
  CANCELINVITATION_RESET,
  CANCELINVITATION_SUCCESS,
  CLEAR_CANCELINVITATION,
  CLEAR_DELETE_INVESTOR,
  CLEAR_GENECODE,
  CLEAR_RESENDSERID,
  DELETE_INVESTOR_FAILURE,
  DELETE_INVESTOR_REQUEST,
  DELETE_INVESTOR_RESET,
  DELETE_INVESTOR_SUCCESS,
  DOWNLOAD_FILE_FAILED,
  DOWNLOAD_FILE_FALSE,
  DOWNLOAD_FILE_SUCCESS,
  DOWNLOAD_FILE_TRUE,
  GENERATECODE_FAILURE,
  GENERATECODE_REQUEST,
  GENERATECODE_RESET,
  GENERATECODE_SUCCESS,
  INVITE_COUNTRY_CODE_FAILURE,
  INVITE_COUNTRY_CODE_REQUEST,
  INVITE_COUNTRY_CODE_SUCCESS,
  PERMISSION_FAILURE,
  PERMISSION_REQUEST,
  PERMISSION_RESET,
  PERMISSION_SUCCESS,
  SENDINVITATION_FAILURE,
  SENDINVITATION_REQUEST,
  SENDINVITATION_RESET,
  SENDINVITATION_SUCCESS,
  SHOW_DOWNLOAD_FILE_NOTI_FALSE,
  SHOW_DOWNLOAD_FILE_NOTI_TRUE,
  USER_LIST_DELETE_NOTIFICATION,
  USER_REPORT_INFO_FAILURE,
  USER_REPORT_INFO_REQUEST,
  USER_REPORT_INFO_RESET,
  USER_REPORT_INFO_SUCCESS,
  USERDETAIL_CLEAR_RESENDSERID,
  USERDETAIL_INITIAL,
  USERLIST_CLEAR_SEARCH_DATA,
  USERLIST_FAILURE,
  USERLIST_REQUEST,
  USERLIST_SAVE_SEARCH_DATA,
  USERLIST_SUCCESS,
} from './constants';

export const permissionAction = {
  request: data => ({
    type: PERMISSION_REQUEST,
    data,
  }),
  success: data => ({
    type: PERMISSION_SUCCESS,
    data,
  }),
  failure: error => ({
    type: PERMISSION_FAILURE,
    error,
  }),
  reset: () => ({
    type: PERMISSION_RESET,
  }),
};

export const userlistActionAll = {
  request: data => {
    const { permission } = data;
    const flag = permission && permission.featureList.find(item => item === 'MANAGE_USER');
    return {
      type: flag ? USERLIST_REQUEST : BLANK,
    };
  },
  success: data => ({
    type: USERLIST_SUCCESS,
    data,
  }),
  failure: error => ({
    type: USERLIST_FAILURE,
    error,
  }),
};

export const generateCodeAction = {
  request: data => ({
    type: GENERATECODE_REQUEST,
    data,
  }),
  success: data => ({
    type: GENERATECODE_SUCCESS,
    data,
  }),
  failure: error => ({
    type: GENERATECODE_FAILURE,
    error,
  }),
  reset: () => ({
    type: GENERATECODE_RESET,
  }),
};

export const resendInvitationAction = {
  request: data => ({
    type: SENDINVITATION_REQUEST,
    data,
  }),
  success: data => ({
    type: SENDINVITATION_SUCCESS,
    data,
  }),
  failure: error => ({
    type: SENDINVITATION_FAILURE,
    error,
  }),
  reset: () => ({
    type: SENDINVITATION_RESET,
  }),
};

export const userReportInfoAction = {
  request: data => ({
    type: USER_REPORT_INFO_REQUEST,
    data,
  }),
  success: data => ({
    type: USER_REPORT_INFO_SUCCESS,
    data,
  }),
  failure: error => ({
    type: USER_REPORT_INFO_FAILURE,
    error,
  }),
  reset: () => ({
    type: USER_REPORT_INFO_RESET,
  }),
};

export const userDetailInitialAction = {
  type: USERDETAIL_INITIAL,
};

export const userDetailClearResendUserIdAction = {
  type: USERDETAIL_CLEAR_RESENDSERID,
};

export const clearResendInvitionAction = {
  type: CLEAR_RESENDSERID,
};

export const clearGeneCodeAction = {
  type: CLEAR_GENECODE,
};

export const downloadFileTrueAction = () => ({
  type: DOWNLOAD_FILE_TRUE,
});

export const downloadFileFalseAction = () => ({
  type: DOWNLOAD_FILE_FALSE,
});

export const downloadFileSuccessAction = () => ({
  type: DOWNLOAD_FILE_SUCCESS,
});

export const downloadFileFailedAction = ({ errorType }) => ({
  type: DOWNLOAD_FILE_FAILED,
  data: errorType,
});

export const showDownloadFileNotiTrueAction = () => ({
  type: SHOW_DOWNLOAD_FILE_NOTI_TRUE,
});

export const showDownloadFileNotiFalseAction = () => ({
  type: SHOW_DOWNLOAD_FILE_NOTI_FALSE,
});

export const cancelInvitationAction = {
  request: data => ({
    type: CANCELINVITATION_REQUEST,
    data,
  }),
  success: data => ({
    type: CANCELINVITATION_SUCCESS,
    data,
  }),
  failure: error => ({
    type: CANCELINVITATION_FAILURE,
    error,
  }),
  reset: () => ({
    type: CANCELINVITATION_RESET,
  }),
};

export const clearCancelInvitionAction = {
  type: CLEAR_CANCELINVITATION,
};

export const deleteInvestorAction = {
  request: data => ({
    type: DELETE_INVESTOR_REQUEST,
    data,
  }),
  success: data => ({
    type: DELETE_INVESTOR_SUCCESS,
    data,
  }),
  failure: error => ({
    type: DELETE_INVESTOR_FAILURE,
    error,
  }),
  reset: () => ({
    type: DELETE_INVESTOR_RESET,
  }),
};

export const userListDeleteNotificationAction = flag => ({
  type: USER_LIST_DELETE_NOTIFICATION,
  flag,
});

export const clearDeleteInvestorAction = () => ({
  type: CLEAR_DELETE_INVESTOR,
});

export const userlistClearSearchDataAction = () => ({
  type: USERLIST_CLEAR_SEARCH_DATA,
});

export const userlistSaveSearchDataAction = data => ({
  type: USERLIST_SAVE_SEARCH_DATA,
  data,
});

export const getCountryCodeListAction = {
  request: data => ({
    type: INVITE_COUNTRY_CODE_REQUEST,
    data,
  }),
  success: data => ({
    type: INVITE_COUNTRY_CODE_SUCCESS,
    data,
  }),
  failure: error => ({
    type: INVITE_COUNTRY_CODE_FAILURE,
    error,
  }),
};
